export default {
  label: {
    title: 'Adicionar componente?',
    description: 'As regras de privacidade das redes sociais e a Lei Geral de Proteção de Dados Pessoais (LGPD) estabelecem que os componentes que possuem informações dos autores das publicações não devem ser acessadas por usuários convidados. Como o seu dashboard está compartilhado, ao adicionar este componente, ele será ocultado para esses usuários.',
    button: {
      confirmButton: 'Adicionar',
      cancelButton: 'Cancelar',
    },
    message: {
      cancel: 'O componente não foi adicionado ao dashboard.',
    },
  },
};
